import React from "react";

import ChatSearchPanel from "./ChatSearchPanel";

import "../../../ChatStyle.less";
import { useSelector, DefaultRootState } from "react-redux";
import { useChat } from "../../../../../../../context/ChatContext/ChatContext";

import ChatMessagesRoomsList from "./RoomsLists/ChatMessagesRoomsList";
import ChatUsersRoomList from "./RoomsLists/ChatUsersRoomList";
import ChatBotRoomsList from "./RoomsLists/ChatBotRoomsList";
import { useIntl } from "react-intl";

interface ChatRoomListProps {
   onOpenCreateModal: () => void;
}

const ChatRoomsList: React.FC<ChatRoomListProps> = ({ onOpenCreateModal }) => {
   const { currentRoomsListFolder } = useSelector((state: DefaultRootState) => state.chatSettings);
   const { oldId } = useSelector((state: DefaultRootState) => state.user);

   const intl = useIntl();

   return (
      <div className="chat-main-rooms-list-container">
         <div className="chat-main-rooms-list-container__folder-name">
            <span>{currentRoomsListFolder}</span>
            <div
               onClick={onOpenCreateModal}
               style={{ cursor: "pointer" }}
               title={intl.formatMessage({ id: "chat.addNewChat" })}
               className="add-room-button"
            >
               <span className="material-symbols-outlined">add</span>
            </div>
         </div>
         <div>
            <ChatSearchPanel />
         </div>
         <div className="chat-main-rooms-list-container__folder">
            <div className="chat-room-list-container">
               {currentRoomsListFolder === "Messages" && <ChatMessagesRoomsList oldId={oldId} />}
               {currentRoomsListFolder === "Contacts" && <ChatUsersRoomList />}
               {currentRoomsListFolder === "Bots" && <ChatBotRoomsList />}
            </div>
         </div>
      </div>
   );
};

export default ChatRoomsList;
